import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';
import { NavLink } from 'react-router-dom';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { PageSkeleton } from "./PageSkeleton";
import { truncateText } from '../utils/utils.fucntions';
import { WhyChooseUs } from './subcomponents/WhychoosUs';
import { useIsMobile } from '../contexts/MobileContext';
import { routes } from '../utils/utils.routes';

const ArrowForward = IoIosArrowForward as any;
const ArrowBack = IoIosArrowBack as any;

export const HeroCarousel: React.FC<HeroCarouselProps> = ({ articles, isLoading }) => {
    const { isMobile } = useIsMobile();

    if (isLoading) {
        return <PageSkeleton />;
    }

    if (!articles || articles.length === 0) {
        return null;
    }

    return (
        <div className="relative w-full hero-carousel-container">
            <Swiper
                modules={[Autoplay, Pagination, Navigation, EffectFade]}
                effect="cube"
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                pagination={{ clickable: true, dynamicBullets: true }}
                navigation={{
                    nextEl: '.swiper-button-next-custom',
                    prevEl: '.swiper-button-prev-custom',
                }}
                loop={true}
                className="h-[500px] md:h-[600px] lg:h-[700px]"
            >
                {articles.map((article) => (
                    <SwiperSlide key={article.id}>
                        <div className="relative w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${article.coverImage})` }}>
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" />

                            <div className="relative z-10 h-full flex items-center">
                                <div className="container mx-auto px-5 xl:px-5 lg:px-5 md:px-8">
                                    <div className="max-w-3xl text-white">
                                        <span className="inline-block px-3 py-1 text-xs font-semibold uppercase bg-primary rounded-full mb-4">
                                            {article.category}
                                        </span>
                                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4 text-uppercase">
                                            {isMobile ? truncateText(article.title, 65) : article.title}
                                        </h2>
                                        <p className="text-base md:text-lg text-gray-100 mb-6 line-clamp-3">
                                            {truncateText(article.excerpt, 200)}
                                        </p>
                                        <NavLink
                                            to={`${routes.ARTICLESDETAILS}/${article.slug}`}
                                            className="wp-block-button__link wp-element-button bg-white/20 backdrop-blur-md"
                                            style={{ flex: 1, display: "flex", flexDirection: "row", alignContent: "center", alignItems: "center", maxWidth: 180, justifyContent: "space-between" }}
                                        >
                                            Lire la suite
                                            <ArrowForward size={18} />
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <WhyChooseUs />

            <button className="swiper-button-prev-custom absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/40 text-white rounded-full p-3 transition-all duration-200 focus:outline-none">
                <ArrowBack size={24} />
            </button>
            <button className="swiper-button-next-custom absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/40 text-white rounded-full p-3 transition-all duration-200 focus:outline-none">
                <ArrowForward size={24} />
            </button>
        </div>
    );
};